
export const FETCH_SYNTHESE_ANNEE_REQUEST = 'FETCH_SYNTHESE_ANNEE_REQUEST';
export const FETCH_SYNTHESE_ANNEE_SUCCESS = 'FETCH_SYNTHESE_ANNEE_SUCCESS';
export const FETCH_SYNTHESE_ANNEE_FAILURE = 'FETCH_SYNTHESE_ANNEE_FAILURE';
export const REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN';